<form (ngSubmit)="onSubmit(EditPartnerUserForm)" #EditPartnerUserForm="ngForm">
  <p-dialog [(visible)]="displayEditDialogInput" [modal]="true" [positionTop]="50" [maximizable]="true"
    (onHide)="dialogClose()" (onShow)="dialogOpen()">

    <p-header>
      <b>Edit Partner User</b>
    </p-header>
    <div class="ui-grid ui-grid-responsive formcontainer custom-dialog-content">
        <p-fieldset>
          <p-header class="fieldsetHeader">User Details</p-header>
          <div class="formgroup">
            <div class="ui-grid-row">
              <div class="ui-grid-col-12">
                <label for="Email">Email Address:</label>
              </div>
            </div>
          </div>
          <div class="ui-grid-row">
            <div class="ui-grid-col-6">
              {{partnerDetails.PartnerUser.Person.Email}}
            </div>
            <div class="ui-grid-col-6" *ngIf="showPasswordResetSection(partnerDetails.PartnerUser,partnerDetails)">
              <div class="align-right">
                <a (click)="showResetCancelButtons()" *ngIf="showResetPasswordLink" class="anchorClass">Reset Password</a>
              </div>
              <div *ngIf="enableResetCancelButtons" class="align-right">
                <button  type="button" (click)="emailResetPasswordLink()" class="green-button">Confirm Reset</button>
                <button  type="button" (click)="hideResetCancelButtons()" class="red-button">Cancel</button>
              </div>
              <div *ngIf="emailStatus" class="align-right">
                <span class="check-circle-green" style="font-size:18px">
                  <i class="pi pi-check-circle check-circle-font"></i>
                  <span class="messageStatus">Password Reset and link email sent</span>
                </span>
              </div>
              <i class="pi pi-spin pi-spinner spinner-font" *ngIf="loading"></i>
            </div>
            <div class="ui-grid-col-6" *ngIf="partnerDetails.PartnerUser.Person.IsPreReg">
              <button pButton type="button" label="Reset/Resend Initial Email" class="ui-button-secondary"
                (click)="resendEmail()"></button>
            </div>
          </div>

          <div class="formgroup">
            <div class="ui-grid-row">
              <div class="ui-grid-col-12">
                <label for="UniqueKey">Unique Key:</label>
              </div>
            </div>
            <div class="ui-grid-row">
              <div class="ui-grid-col-12">
                <input type="text" pInputText [(ngModel)]="partnerDetails.PartnerUser.UniqueKey" name="UniqueKey"
                  id="UniqueKey" maxlength="50" size="50">
              </div>
            </div>
          </div>
        </p-fieldset>

        <p-fieldset>
            <p-header class="fieldsetHeader">Partner Details</p-header>
            <div class="formgroup">
              <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                  <label for="Name">Name:</label>
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                  {{partnerDetails.PartnerUser.Person.FirstName}} {{partnerDetails.PartnerUser.Person.LastName}}
                </div>
              </div>
            </div>

            <div class="formgroup">
              <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                  <label for="PartnerType">Partner Type:</label>
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                  {{relationshipData.RelationshipType}}
                </div>
              </div>
            </div>

            <div class="formgroup">
              <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                  <label for="Company">Partner:</label>
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                  {{relationshipData.CompanyName}}
                </div>
              </div>
            </div>

            <div class="formgroup">
              <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                  <label for="MasterAssetGroup">Master Asset Group:</label>
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                  {{assetGroupList}}
                </div>
              </div>
            </div>

            <div class="formgroup">
              <div class="ui-grid-row">
                <div class="ui-grid-col-6">
                  <label for="partnerstatus">User’s Partnership Status</label><br>
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col-10">
                  <p-dropdown [options]="partnerStatus" optionLabel="name" name="partnerStatus"
                    [(ngModel)]="currentPartnerStatus" (onChange)="partnerStatusChange()"></p-dropdown>
                  <span class="scroll-message" *ngIf="partnerDetails.PartnerUser.IsPrimary && !partnerDetails.PartnerUser.Person.IsActive && !isPrimaryContactSelected">Please scroll down to select a new primary contact</span>
                </div>
              </div>
            </div>
      
            <div class="formgroup">
                <div class="ui-grid-row">
                    <div class="ui-grid-col-12">
                      <label for="Privileges">Privileges<span class="custom-required">*</span></label>
                    </div>
                </div>
                <div class="ui-grid-row">
                  <app-privilege-dropdown
                    [privilegeGroup]="partnershipPrivileges" 
                    [preSelectedPrivilege]="userPrivileges"
                    [maxSelectedLabels]="1"
                    [group]=true
                    defaultLabel="Select Privilege" 
                    filterPlaceHolder=""
                    (onChange)="privilegeChange($event)">
                  </app-privilege-dropdown>
                  <i class="pi pi-info-circle" style="font-size:24px"
                    pTooltip="Privileges control what each user is able to see and do in the EQ Connect Portal.  If this user is given the privilege to add/edit other users in the Portal, they can only give other users the privileges they have."></i>
                  <span [ngClass]="{'check-circle-gray': selectedItemsNow?.length <=0,
                                              'check-circle-green': selectedItemsNow?.length > 0}">
                    <i class="pi pi-check-circle"></i>
                  </span>
                </div>
                <span *ngIf="selectedItemsNow?.length <=0" class="custom-error">Privileges are required</span>
              </div>
              <div class="formgroup" *ngIf = "partnerDetails.PartnerUser.IsPrimary && !partnerDetails.PartnerUser.Person.IsActive">
                <div class="ui-grid-row">
                    <div class="ui-grid-col-12">
                      <label for="ChangePrimaryContact">Update Primary Contacts<span class="custom-required">*</span></label>
                    </div>
                </div>
                <div class="ui-grid-row">
                  <div class="ui-grid-col-12">
                    <app-change-primary-contact 
                      [PersonId]="partnerDetails.PartnerUser.Person.PersonId"
                      [DisplayRelationshipIds]="[relationshipData.RelationshipXrefId]"
                      (RelationshipAndContactId)="mapRelationshipAndContactId($event)"
                      (IsPrimaryContactReady)="checkIsPrimaryContactReady($event)" >
                    </app-change-primary-contact>
                  </div>
                </div>
              </div>
          </p-fieldset>
    </div>
    <p-footer>
      <button pButton type="button" label="Cancel" class="ui-button-secondary" (click)="dialogClose()"></button>
      <button pButton type="submit" label="{{processing ? 'Processing' : 'Update User'}}"
        [disabled]="!EditPartnerUserForm.form.valid || selectedItemsNow?.length <=0 || processing || !isPrimaryContactSelected"></button>
      <br /><br />

      <div class="ui-grid ui-grid-responsive formcontainer custom-dialog-content">
        <div class="ui-grid-row history-row">
          <div class="ui-grid-col-12 left"><label>User History</label>
            <hr />
          </div>
        </div>
        <div class="ui-grid-row history-row">
          <div class="ui-grid-col-12">Created By</div>
          <div class="ui-grid-col-12">{{ partnerDetails.PartnerUser.CreatedByEmail }}</div>
        </div>
        <div class="ui-grid-row history-row">
          <div class="ui-grid-col-12">Date</div>
          <div class="ui-grid-col-12">{{ partnerDetails.PartnerUser.CreatedAt | date:'medium' }}</div>
        </div>
        <div class="ui-grid-row history-row">
          <div class="ui-grid-col-12">Modified By</div>
          <div class="ui-grid-col-12">{{ partnerDetails.PartnerUser.UpdatedByEmail }}</div>
        </div>
        <div class="ui-grid-row history-row">
          <div class="ui-grid-col-12">Date</div>
          <div class="ui-grid-col-12">{{ partnerDetails.PartnerUser.UpdatedAt | date:'medium' }}</div>
        </div>
      </div>
    </p-footer>
  </p-dialog>
</form>
<p-confirmDialog header="User Status" icon="pi pi-exclamation-triangle"></p-confirmDialog>